import { Children, cloneElement } from 'react';

import { usePopoverContext } from './context';

import type { FC, ReactElement } from 'react';

export interface ToggleProps {
  children: ReactElement;
}

export const PopoverToggle: FC<ToggleProps> = ({ children }) => {
  const { handleToggle } = usePopoverContext();

  return (
    <>
      {Children.map(children, (child) =>
        cloneElement(child, {
          onClick: handleToggle,
        })
      )}
    </>
  );
};
